import { BaseText, HeadingTag } from '@/common/pd-meta-components-types'
import PdTextMatchSup from '@/components/pd-text-match-sup/pd-text-match-sup'
import SemanticText from '@/components/standard/semantic-text'
import clsx from 'clsx'
import { FC } from 'react'

const TitleAndDesc: FC<
  BaseText & { titleTag?: HeadingTag | null; containerClass?: string; titleClass?: string; descClass?: string }
> = ({
  title,
  desc,
  titleTag,
  containerClass,
  titleClass,
  descClass,
}) => {
  return (
    <div className={clsx('w-full max-w-300 mx-auto', 'px-6 laptop:px-0', 'laptop:text-center', containerClass)}>
      {title && (
        <SemanticText
          as={titleTag}
          defaultTag="h3"
          className={clsx(
            'font-semibold',
            'mb-3 laptop:mb-6',
            'whitespace-pre-wrap break-words',
            'text-fc-primary pd-first-title',
            titleClass
          )}
        >
          <PdTextMatchSup className="" supClassName="" text={title}></PdTextMatchSup>
        </SemanticText>
      )}
      {desc && (
        <p
          className={clsx(
            'max-w-180 mx-auto',
            'mb-8 laptop:mb-16',
            'whitespace-pre-wrap break-words',
            'text-fc-primary pd-main-text',
            descClass
          )}
        >
          <PdTextMatchSup className="" supClassName="" text={desc}></PdTextMatchSup>
        </p>
      )}
    </div>
  )
}

export default TitleAndDesc
